// src/components/Header.js
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/img/logo/logo.jpeg";
import QuoteModal from "./Quote/quoteModal";
import Modal from "./Common/modal";
import Enquire from "./Quote/enquire";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openEnquire, setOpenEnquire] = useState(false);

  const [productOpen, setProductOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // Handle navigation + close menu
  const handleLinkClick = (path) => {
    setMobileMenuOpen(false); // Close the mobile menu
    navigate(path); // Navigate to the route
  };
  const menuRef = useRef(null);

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setMobileMenuOpen(false);
  //     }
  //   }

  //   if (mobileMenuOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   // Cleanup event listener on unmount or when mobileMenuOpen changes
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [menuRef.current]);
  console.log("mobileMenuOpen", mobileMenuOpen);

  return (
    <header id="header" className=" bg-[#1a1715] fixed-top">
      <div className="nav-wrap">
        <div className="container mx-auto px-4 py-2 lg:py-1 ">
          <div className="flex items-center justify-between ">
            <a href="/" className="flex items-center justify-center space-x-2 ">
              <img
                src={logo}
                alt="Cart Studio Logo"
                className="h-10 w-10 rounded-full"
              />
              <div className="text-lg  font-semibold text-white flex flex-col ">
                <span>CART STUDIO</span>
                {/* <span className="text-sm text-orange-600 capitalize">
                  You think We make
                </span> */}

                {/* <p className="text-sm text-orange-600 capitalize">
                  You think We make
                </p> */}
              </div>
            </a>

            <nav className="hidden  lg:flex justify-center flex-1 navmenu">
              <ul>
                <li>
                  <Link to="/" className={currentPath === "/" ? "active" : ""}>
                    Home
                  </Link>
                </li>

                <li className="dropdown">
                  <Link
                    to="/product"
                    className={currentPath === "/product" ? "active" : ""}
                  >
                    <span>Product</span>
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/parlour-on-wheels"
                        className={
                          currentPath === "/parlour-on-wheels" ? "active" : ""
                        }
                      >
                        Parlour on Wheels
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tricycle-carts"
                        className={
                          currentPath === "/tricycle-carts" ? "active" : ""
                        }
                      >
                        Tricyle Carts/Push Cart
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/e-carts"
                        className={currentPath === "/e-carts" ? "active" : ""}
                      >
                        E-carts / E Rickshaw
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link
                    to="/about"
                    className={currentPath === "/about" ? "active" : ""}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blogs"
                    className={currentPath === "/blogs" ? "active" : ""}
                  >
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className={currentPath === "/contact" ? "active" : ""}
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/quote"
                    className={currentPath === "/quote" ? "active" : ""}
                  >
                    Get a Quote
                  </Link>
                </li>
                {/* <li
                  onClick={() => setIsModalOpen(true)}
                  className={
                    currentPath === "/quote"
                      ? "active"
                      : "text-gray-300 hover:text-orange-600 font-semibold cursor-pointer"
                  }
                >
                  Get a Quote
                </li> */}
              </ul>
            </nav>

            <div className="flex gap-4 ">
              <div>
                <button
                  onClick={() => setOpenEnquire(true)}
                  className="text-orange-500 border border-light bg-white px-2 py-1 rounded active:scale-95"
                >
                  <i class="bi bi-person-badge lg:hidden"></i>{" "}
                  <span className="hidden lg:block">Enquire Now</span>
                </button>
              </div>
              <div
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden text-white text-2xl"
              >
                <i className="bi bi-list"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      {mobileMenuOpen && (
        <div
          ref={menuRef}
          className="xl:hidden bg-gray-700 text-white p-2 rounded-lg shadow-lg w-full"
        >
          <ul className="divide-y divide-gray-900">
            <li className="py-2">
              <button
                onClick={() => handleLinkClick("/")}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                Home
              </button>
            </li>

            <li className="py-2">
              <div className="flex justify-between items-center">
                <button
                  onClick={() => handleLinkClick("/product")}
                  className={`flex-1 text-left font-medium transition-colors duration-200 ${
                    currentPath === "/product"
                      ? "text-orange-400"
                      : "hover:text-orange-400"
                  }`}
                >
                  Product
                </button>

                <button
                  type="button"
                  onClick={(e) => {
                    e?.stopPropagation();
                    setProductOpen(!productOpen);
                  }}
                  className="text-orange-400 hover:text-white transition-colors duration-200 mr-5"
                >
                  <i
                    className={`bi text-lg transition-transform duration-300 ${
                      productOpen ? "bi-chevron-up" : "bi-chevron-down"
                    }`}
                  ></i>
                </button>
              </div>

              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  productOpen ? "max-h-96 mt-2" : "max-h-0"
                }`}
              >
                <ul className="pl-4 mt-2 space-y-2 text-sm text-gray-300">
                  <li>
                    <button
                      onClick={() => handleLinkClick("/parlour-on-wheels")}
                      className={`w-full text-left transition-colors ${
                        currentPath === "/parlour-on-wheels"
                          ? "text-orange-400"
                          : "hover:text-orange-400"
                      }`}
                    >
                      Parlour on Wheels
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleLinkClick("/tricycle-carts")}
                      className={`w-full text-left transition-colors ${
                        currentPath === "/tricycle-carts"
                          ? "text-orange-400"
                          : "hover:text-orange-400"
                      }`}
                    >
                      Tricycle Carts / Push Cart
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleLinkClick("/e-carts")}
                      className={`w-full text-left transition-colors ${
                        currentPath === "/e-carts"
                          ? "text-orange-400"
                          : "hover:text-orange-400"
                      }`}
                    >
                      E-carts / E-rickshaw
                    </button>
                  </li>
                </ul>
              </div>
            </li>

            <li className="py-2">
              <button
                onClick={() => handleLinkClick("/about")}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/about"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                About Us
              </button>
            </li>

            <li className="py-2">
              <button
                onClick={() => handleLinkClick("/blogs")}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/blogs"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                Blogs
              </button>
            </li>

            <li className="py-2">
              <button
                onClick={() => handleLinkClick("/contact")}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/contact"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                Contact Us
              </button>
            </li>

            <li className="py-2">
              <button
                onClick={() => handleLinkClick("/quote")}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/quote"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                Get a Quote
              </button>
            </li>

            {/* Quote */}
            {/* <li className="py-2">
              <button
                onClick={() => setIsModalOpen(!isModalOpen)}
                className={`w-full text-left font-medium transition-colors duration-200 ${
                  currentPath === "/quote"
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                }`}
              >
                Get a Quote
              </button>
            </li> */}
          </ul>
        </div>
      )}

      {/* Modal */}
      {/* <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <QuoteModal />
      </Modal> */}

      {/* //Enquire modal  */}
      <Modal isOpen={openEnquire} onClose={() => setOpenEnquire(false)}>
        <Enquire setOpenEnquire={setOpenEnquire} />
      </Modal>
    </header>
  );
};

export default Header;
